import React from 'react';
import { Box, Typography } from '@mui/material';

const EpisodeItem = ({ episode, image, title, selected, playEpisode }) => {
  return (
    <Box
      onClick={() => playEpisode(episode)}
      sx={{
        position: 'relative',
        cursor: 'pointer',
        padding: '1.7rem 0',
        transition: 'transform 0.3s ease',
        transformOrigin: 'center center',
        '&:hover': {
          transform: 'scale(1.2)',
          zIndex: 2,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          paddingTop: '56.25%', // 16:9 aspect ratio
          overflow: 'hidden',
          borderRadius: '0.2rem',
        }}
      >
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: 'white',
          fontSize: '1rem',
          marginTop: '0.5rem',
          textAlign: 'center',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default EpisodeItem;
